import writeXlsxFile from "write-excel-file";
import { getAllVehicles } from "../../../utils/services/vehicles";
// moment
import moment from "moment/moment";

export async function createVeiculoXlsx({
  jwt,
  idEvent,
  limit,
  countData,
  setFinishExport,
}) {
  const formatDate = (date) => {
    if (!date) return "";
    const formatedDate = date.split("T")[0].split("-").reverse().join("/");
    if (date.split("T")[0].includes("1969")) return "";
    return `${formatedDate} ${date.split("T")[1].substring(0, 5)}`;
  };

  const normalizeStatus = (status) => status?.trim() || "Pendente";

  const formatParticipant = ({ email, status }) =>
    `${email} (${normalizeStatus(status)})`;

  const schema = [
    {
      column: "ID",
      type: String,
      value: (v) => v.id,
    },
    {
      column: "TipoDeTransfer",
      type: String,
      value: (v) => v.transferType,
    },
    {
      column: "Nome",
      type: String,
      value: (v) => v.description,
    },
    {
      column: "Origem",
      type: String,
      value: (v) => v.origin,
    },
    {
      column: "Destino",
      type: String,
      value: (v) => v.destination,
    },
    {
      column: "DataSaída",
      type: String,
      value: (v) => moment(v.departureDatetime).format("DD/MM/YYYY"),
    },
    {
      column: "HoraSaída",
      type: String,
      value: (v) => moment(v.departureDatetime).add(3, "hours").format("HH:mm"),
    },

    {
      column: "Data/Hora de Saída Real",
      type: String,
      value: (v) =>
        v.realDepartureDatetime
          ? moment(v.realDepartureDatetime)
              .add(3, "hours")
              .format("DD/MM/YYYY H:mm")
          : "",
    },
    {
      column: "DataChegada",
      type: String,
      value: (v) =>
        v.arrivalDatetime ? moment(v.arrivalDatetime).format("DD/MM/YYYY") : "",
    },
    {
      column: "HoraChegada",
      type: String,
      value: (v) =>
        v.arrivalDatetime
          ? moment(v.arrivalDatetime).add(3, "hours").format("HH:mm")
          : "",
    },

    {
      column: "Data/Hora de Chegada Google Maps",
      type: String,
      value: (v) =>
        v?.estimatedArrival
          ? moment(v?.estimatedArrival)
              .add(3, "hours")
              .format("DD/MM/YYYY H:mm")
          : "",
    },
    {
      column: "Data/Hora de Chegada Real",
      type: String,
      value: (v) =>
        v.realArrivalDatetime
          ? moment(v?.realArrivalDatetime)
              .add(3, "hours")
              .format("DD/MM/YYYY H:mm")
          : "",
    },
    {
      column: "Capacidade",
      type: Number,
      value: (v) => v.seatingCapacity,
    },
    {
      column: "Utilizado",
      type: Number,
      value: (v) => v.amount,
    },
    {
      column: "TipoVeículo",
      type: String,
      value: (v) => v.vehicleType,
    },
    {
      column: "Empresa",
      type: String,
      value: (v) => v.company,
    },
    {
      column: "NomeDoMotorista",
      type: String,
      value: (v) => v.driverName,
    },
    {
      column: "TelefoneDoMotorista",
      type: String,
      value: (v) => v.phone,
    },
    {
      column: "NomeDoCoordenador",
      type: String,
      value: (v) => (v.coordinatorName ? v.coordinatorName : ""),
    },
    {
      column: "TelefoneDoCoordenador",
      type: String,
      value: (v) => (v.coordinatorPhone ? v.coordinatorPhone : ""),
    },
    {
      column: "PontoDeEncontro",
      type: String,
      value: (v) => v.meetingPoint,
    },
    {
      column: "Observação",
      type: String,
      value: (v) => v.notes,
    },
    {
      column: "Participantes",
      type: String,
      value: (v) => v.participants.map(formatParticipant).join(", "),
    },
     {
      column: "Grupos",
      type: String,
      value: (v) =>
        v.grupos && v.grupos.length > 0
          ? v.grupos.map((e) => e.name).join(",")
          : "",
    },
    {
      column: "Programado",
      type: String,
      value: (v) => {
        const date = v?.vehicleStatus?.find(
          (vs) => vs.status === "Programado",
        )?.dateRegistration;

        return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
      },
    },
    {
      column: "Embarcando",
      type: String,
      value: (v) => {
        const date = v?.vehicleStatus?.find(
          (vs) => vs.status === "Embarcando",
        )?.dateRegistration;

        return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
      },
    },
    {
      column: "Em Trânsito",
      type: String,
      value: (v) => {
        const date = v?.vehicleStatus?.find(
          (vs) => vs.status === "Em Trânsito",
        )?.dateRegistration;

        return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
      },
    },
    {
      column: "Finalizado",
      type: String,
      value: (v) => {
        const date = v?.vehicleStatus?.find(
          (vs) => vs.status === "Finalizado",
        )?.dateRegistration;

        return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
      },
    },
    {
      column: "DiárioDeBordo",
      type: String,
      value: (v) => v?.vehicleLogbook,
    },
    {
      column: "AlertaOperacional",
      type: String,
      value: (v) => (v.operationalAlert ? v.operationalAlert : ""),
    },
    {
      column: "ExibirAlerta",
      type: String,
      value: (v) => (v.showOperationalAlert ? "Sim" : "Não"),
    },
    {
      column: "Cancelado",
      type: String,
      value: (v) => {
        const date = v?.vehicleStatus?.find(
          (vs) => vs.status === "Cancelado",
        )?.dateRegistration;

        const note = v?.vehicleStatus?.find(
          (vs) => vs.status === "Cancelado",
        )?.notes;

        return date
          ? moment(date).format("DD/MM/YYYY HH:mm") + " - " + note
          : "";
      },
    },
    {
      column: "Data e Hora da Criação",
      type: String,
      value: (v) =>
        v.createdAt
          ? moment(v.createdAt).add(3, "hours").format("DD/MM/YYYY H:mm")
          : "",
    },
    {
      column: "Data e Hora da Atualização",
      type: String,
      value: (v) =>
        v.createdAt
          ? moment(v.updatedAt).add(3, "hours").format("DD/MM/YYYY H:mm")
          : "",
    },
  ];

  const allRequestsPromises = [];
  const numberOfRequisitions = Math.ceil(countData / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await getAllVehicles(idEvent, i, limit, "", "");
    // }).then((response) => console.log(response));
    // return;
    allRequestsPromises.push(request);
    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");
    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0,
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }

  const allDataInSingleArray = allRequestsPromises
    .map((e) => e.data.findAll.data)
    .flat();
  if (allDataInSingleArray) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "veiculos.xlsx",
    });
  }
}
